(function () {
	'use strict';
	angular.module('dcApp').factory('MetadataService', [
		'$http',
		'$q',
		'$rootScope',
		'httpService',
		'API_BASE_URL_BACKEND',
		function ($http, $q, $rootScope, httpService, API_BASE_URL_BACKEND) {
			var MetadataService = {},
				endpoint = API_BASE_URL_BACKEND + 'metadata';

			MetadataService.getMetadataList = function () {
				return httpService.getRequest(endpoint);
			};

			MetadataService.saveMetadata = function (metadata) {
				return httpService.putRequest(endpoint, metadata, false);
			};

			MetadataService.getElementIdByMetadataId = function (metadataId, type) {
				let url = endpoint + '/' + metadataId + '/' + type;
				return httpService.getRequest(url);
			};

			MetadataService.getMetadataTrace = function (metadataId) {
				let url = endpoint + '/' + metadataId + '/trace';
				return httpService.getRequest(url);
			};

			MetadataService.getMatadataUniqueCode = function () {
				let url = API_BASE_URL_BACKEND + $rootScope.getUrl('METADATA_UNIQUE_CODE');
				return httpService.getRequest(url);
			};

			return MetadataService;
		},
	]);
})();
